import { render, staticRenderFns } from "./SalesReportNew.vue?vue&type=template&id=2b636048&"
import script from "./SalesReportNew.vue?vue&type=script&lang=js&"
export * from "./SalesReportNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports